module.exports = __webpack_public_path__ + "static/img/down.bbe5a1db.png";